import { useEffect, useState } from 'react';

export default function useNodeTypeDefinition(nodeTypeKey, getType, nodeTypesRevision) {
  const [typeDef, setTypeDef] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const def = nodeTypeKey ? getType(nodeTypeKey) : undefined;
    setTypeDef(def || null);
    setLoading(false);
  }, [nodeTypeKey, getType, nodeTypesRevision]);

  return { typeDef, loading };
}
